export default __webpack_public_path__ + "static/media/__google_play_icon_black.e193a65f.svg";